<!--
 * @Description: 新闻资讯
 * @Author: pliybird
 * @Date: 2022-01-30 00:14:48
 * @LastEditTime: 2023-09-04 10:56:35
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<template>
  <Layout>
    <!-- class="news-img-h"  -->
    <div class="news-img-h" :style="{ 'background-image': `url(${require(`@/assets/images/news/news_center.jpg`)})` }">
      <!-- <img width="100%" :src="require('@/assets/images/news/news_center.jpg')" alt="" /> -->
    </div>
    <div class="rn-section-gapBottom news-container">
      <div class="container mt_dec--100 pb--40">
        <div class="pb--50"></div>
        <SectionTitle :title="$t('news.content_title')" :sectionTitleStyle="1" textAlign="center"
          description="NEWS CENTER" />
        <div class="row gx-1">
          <div v-for="(item, index) in newsList" :key="index" class="col-12 col-lg-4 col-md-6 col-sm-6 p-3">
            <div class="wrapper rn-card">
              <div class="inner">
                <h4 class="title">{{ item.title }}</h4>
                <div class="thumbnail">
                  <router-link class="image"
                    :to="{ name: 'NewsDetail', params: { lang: $i18n.locale, from: 'news', id: item.id } }">
                    <img class="w-100" :src="baseUrl + '/' + item.logoUrl" :alt="item.title" />
                  </router-link>
                </div>

                <div class="description mt--20">{{ item.content }}</div>
              </div>
              <div class="date-img slider-bg-image"
                :style="{ 'background-image': `url(${require('@/assets/images/news/news_date.png')})` }">
                {{ newsDate(item.publishDate) }}
              </div>
            </div>
          </div>
        </div>
        <Pagination :total="totalCount" :cur-page="curPage" :page-size="9" @current-page="currentPage"></Pagination>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../components/common/Layout";
import Separator from "../components/elements/separator/Separator";
import SectionTitle from "../components/elements/sectionTitle/SectionTitle";
import moment from 'moment';
import { newsList } from "@/helpers/api";
import Pagination from "./Pagination.vue";
export default {
  name: "Home",
  components: { Layout, Separator, SectionTitle, Pagination },
  data() {
    return {
      //   newsCenter: require("../assets/images/news/news_center.png"),
      baseUrl: process.env.VUE_APP_API_URL,
      curPage: 1,
      newsList: [],
      totalCount: 0,
    };
  },
  computed: {
    newsDate() {
      return date => {
        return moment(date).format('MM-DD')
      }

    }
  },
  created() {
    this.getNewsList();
  },
  methods: {
    getNewsList() {
      newsList(`lang=${this.$i18n.locale}&PageIndex=${this.curPage}&PageSize=9`).then((res) => {
        if (res.state == "success") {
          this.newsList = res.data.rows;
          this.totalCount = res.data.totalCount;
        }
      });
    },

    currentPage(curPage) {
      this.curPage = curPage;
      this.getNewsList()
    },
  },
};
</script>
